import Request from "./index";

class Api {
  //获取我的收藏记录
  static getFavoriteList(data) {
    return Request.get("/resource/personal/favorite/page", {
      params: {
        page: data.page,
        page_size: data.page_size
      }
    });
  }

  //获取我的浏览记录
  static getHistoryList(data) {
    return Request.get("/resource/personal/history/page", {
      params: {
        page: data.page,
        page_size: data.page_size
      }
    });
  }
  //删除我的浏览记录
  static deleteHistory(id) {
    // return Request.delete(`/resource/personal/history?id=${id}`);
    return Request.delete(`/resource/personal/history/${id}`);
  }
  //修改密码
  static resetPwd(data) {
    return Request.put("/user/reset_pwd", {
      old_pwd: data.old_pwd,
      new_pwd: data.new_pwd
    });
  }

  //获取手机验证码
  static getVerifyCode(data) {
    return Request.post("/auth/login/send_security_code", {
      phone_number: data.phone_number
    });
  }

  //绑定手机
  static bindPhone(data) {
    return Request.put("/user/bind_phone", {
      phone: data.phone,
      security_code: data.security_code
    });
  }

  //修改用户
  static updateUser(id, data) {
    return Request.put("/user/" + id, data);
  }
}

export default Api;
